// const dampingRatio = {
// 	dampingRatio1: 1,
// 	dampingRatio2: 0.69,
// 	dampingRatio3: 0.64,
// 	dampingRatio4: 0.45,
// };
// const frequencyResponse = {
// 	frequencyResponse1: 0.3,
// 	frequencyResponse2: 0.43,
// 	frequencyResponse3: 0.47,
// 	frequencyResponse4: 0.57,
// };
var stiffness = {
  stiffness1: 120,
  stiffness2: 180,
  stiffness3: 210,
  stiffness4: 439
};
var damping = {
  damping1: 12,
  damping2: 14,
  damping3: 20,
  damping4: 42
};
export var springs = {
  springBounceNone: {
    tension: stiffness.stiffness4,
    friction: damping.damping4
  },
  springBounceDefault: {
    tension: stiffness.stiffness3,
    friction: damping.damping3
  },
  springBounceLight: {
    tension: stiffness.stiffness1,
    friction: damping.damping2
  },
  springBounceHeavy: {
    tension: stiffness.stiffness2,
    friction: damping.damping1
  },
  // deprecated ?
  springBounceFast: {
    tension: stiffness.stiffness3,
    friction: damping.damping3
  }
};
export var easing = {
  easeInOut: 'cubic-bezier(0.5, 0, 0.25, 1)',
  easeOut: 'cubic-bezier(0, 0, 0.25, 1)',
  easeIn: 'cubic-bezier(0.5, 0, 1, 1)'
};
export var duration = {
  duration150: '150ms',
  duration300: '300ms',
  duration450: '450ms',
  duration600: '600ms'
}; // in ms

export var delay = {
  delay60: 60,
  delay100: 100,
  delay140: 140,
  delay200: 200
};